'use client'

import { useReportWebVitals } from 'next/web-vitals'

const coreWebVitals = new Set(['CLS', 'FCP', 'INP', 'LCP', 'TTFB'])

export function WebVitals() {
  useReportWebVitals((metric) => {
    if (!coreWebVitals.has(metric.name)) {
      return
    }

    const formattedValue =
      metric.name === 'CLS' ? metric.value.toFixed(4) : Math.round(metric.value)

    console.info(`[Web Vitals] ${metric.name}: ${formattedValue} (${metric.rating})`, metric)
  })

  return null
}
